const shadows = {};

const radii = {};

export { shadows, radii };
